module.exports = __webpack_public_path__ + "img/mingshi_yaoshi.6ccb63b8.png";